module.exports = "<ul>\n  <li>\n    <a (click)=\"openPatientAgreement()\">{{ 'footer.terms_and_conditions' | translate }}</a>\n  </li>\n  <li>\n    <a (click)=\"openPrivacyStatement()\">{{ 'footer.privacy_policy' | translate }}</a>\n  </li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/navigation-external/navigation-external.component.html
// module id = 1185
// module chunks = 0